export default __webpack_public_path__ + "static/media/500.31fe03f3.png";